(function () {
    const braSizeSlider = document.querySelector('#bra-size-calc');

    let formIntro = document.querySelector('.bra-size-calculator-intro-section');
    let formIntroButton = document.querySelector('.form-intro-close');
    let braSlider = document.querySelector('.bra-size-calculator-slider-section');

    formIntroButton.addEventListener('click', function() {
        formIntro.classList.remove('bra-size-calculator-intro-section--active');
        window.scrollTo(0, 0);
        braSlider.classList.add('bra-size-calculator-slider-section--active');
    });

    /* ATC functionality is not currently set up on the Impact theme */

    // let tmAddToCart = (variant_id, quantity = 1) => {
    //     if (variant_id && quantity > 0) {
    //         var line_item = {
    //             'id': variant_id,
    //             'quantity': quantity
    //         }

    //         fetch('/cart/add.js', {
    //             method: 'POST',
    //             credentials: 'include',
    //             headers: {
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify(line_item)
    //         }).then(r => r.json()).then(item => {
    //             geckoShopify.AJAXUpdateCart()
    //         })
    //     }
    // }


    const howToContainer = document.querySelector('.how-to-container');
    const howTo = howToContainer.querySelector('.how-to');
    let howToDiv = document.querySelector('.carousel-cell .how-to-holder');

    if (howToDiv) {
        howTo.innerHTML = howToDiv.innerHTML;
    }

    const sliderElement = braSizeSlider.querySelector('.bra-size-calc-slider'),
    slider = new Flickity(sliderElement, {
        pageDots: false,
        wrapAround: false,
        draggable: false,
        imagesLoaded: true,
        prevNextButtons: false,
        adaptiveHeight: true,
        selectedAttraction: 0.03,
        friction: 0.3
    }),
    flkty = Flickity.data('.bra-size-calc-slider'),
    backButton = braSizeSlider.querySelector('.slider-button--back'),
    nextButton = braSizeSlider.querySelector('.slider-button--next');

    braSizeSlider.style.opacity = 1;
    
    let sizeAnswers = {},
        dropdownOptions = document.querySelectorAll('.carousel-cell .dropdown .dropdown__option'),
        addToCardButtons = document.querySelectorAll('.bsc-add-to-cart'),
        currentSlide = document.querySelector('.carousel-cell.is-selected'),
        perfectFit,
        perfectBra,
        progressSteps = document.querySelectorAll('.progress-step');

    const emailResultsForm = document.getElementById("emailResultsForm");

    nextButton.addEventListener('click', function() {
        slider.next();
    });
    backButton.addEventListener('click', function() {
        slider.previous();
    });

    slider.on('select', function (index) {
        let dropdown = document.querySelector('.carousel-cell.is-selected .dropdown');

        let resultsPage = document.querySelector('.bs-results'),
            loadingGif = document.querySelector('.crunching-gif');

        dropdownOptions = document.querySelectorAll('.carousel-cell.is-selected .dropdown .dropdown__option');
        currentSlide = document.querySelector('.carousel-cell.is-selected');
        
        if(dropdown) {
            if(dropdown.classList.contains("dropdown--selected")) {
                nextButton.removeAttribute("disabled");
            } else {
                nextButton.setAttribute("disabled", "disabled");
            }
        }

        nextButton.classList.remove("nudge-me");

        howToDiv = document.querySelector('.carousel-cell.is-selected .how-to-holder');

        howTo.style.opacity = 0;
        howTo.style.visibility = 'hidden';

        setTimeout(() => {
            howTo.style.opacity = 1;
            howTo.style.visibility = 'visible';
        }, 600);

        if (howToDiv) {
            howTo.innerHTML = howToDiv.innerHTML;
        } else {
            howTo.innerHTML = "";
        }

        // Show/hide previous/next buttons
        if (!flkty.cells[index - 1]) {
            // on first cell
            backButton.style.display = "none";
        } else if (!flkty.cells[index + 1]) {
            // on last cell
            document.querySelector('.need-help-container').style.display = "none";
            nextButton.style.display = "none";
            backButton.style.display = "none";
            howTo.style.display = "none";

            setTimeout(() => {
                resultsPage.style.visibility = "visible";
                loadingGif.style.display = "none";
            }, 4000);

            // Reset before showing, incase user has changed their inputs
            braSizeSlider.querySelectorAll('.suggestionbox__item').forEach((item) => item.classList.add('hideme'));

            if (perfectBra == "Original") {
                document.querySelector('.suggestoriginal').classList.remove('hideme');
            } else if (perfectBra == "Easy") {
                document.querySelector('.suggesteasyon').classList.remove('hideme');
            } else if (perfectBra == "Both") {
                document.querySelector('.suggestboth').classList.remove('hideme');
            } else if (perfectBra == "None" || perfectBra == "Contact" || perfectBra == "Unavailable") {
                document.querySelector('.suggestunavailable').classList.remove('hideme');
            }

            document.querySelectorAll('.suggestionbox__item .bs-results__size').forEach((item) => item.innerHTML = perfectFit);

            progressSteps[0].parentElement.style.display = "none";

            //slider.resize();

            setTimeout(() => {
                slider.resize();
            }, 300);
        } else {
            backButton.style.display = "block";
            nextButton.style.display = "block";
            howTo.style.display = "flex";
            progressSteps[0].parentElement.style.display = "flex";
        }

        if (!flkty.cells[index + 2]) {
            nextButton.innerHTML = nextButton.innerHTML.replace("Find my size","No thanks, tell me my bra size");
        } else {
            nextButton.innerHTML = nextButton.innerHTML.replace("No thanks, tell me my bra size","Find my size");
        }

        if (!flkty.cells[index + 3]) {
            nextButton.innerHTML = nextButton.innerHTML.replace("Next step","Find my size");
        } else {
            nextButton.innerHTML = nextButton.innerHTML.replace("Find my size","Next step");
        }
        
        let activeSlide = document.querySelector('.progress-step--active');

        if (activeSlide) {
            activeSlide.classList.remove('progress-step--active');
        }
    
        if (progressSteps[index]) {
            progressSteps[index].classList.add('progress-step--active');
            progressSteps[index].classList.remove('progress-step--complete');
        }

        if (progressSteps[index - 1]) {
            progressSteps[index - 1].classList.add('progress-step--complete');
        }

    });

    nextButton.addEventListener("click", function() {
        localStorage.setItem("size", JSON.stringify(sizeAnswers));

        let sizes = localStorage.getItem('size'),
            parseSizes = JSON.parse(sizes),
            underBust = parseSizes.underbust,
            overBust = parseSizes.overbust,
            topSize = parseSizes.topsize;
            //recommededBra;

        for (var i = 0; i < parsed.data.length; i++) {
            if (parsed.data[i].underV == underBust && parsed.data[i].overV == overBust) {
                perfectFit = parsed.data[i].size;
                perfectBra = parsed.data[i].cssclass;

                // if (perfectBra == "Original") {
                //     recommededBra = "Original";
                // } else if (perfectBra == "Easy") {
                //     recommededBra = "Easy";
                // } else if (perfectBra == "Both") {
                //     recommededBra = "Both";
                // } else if (perfectBra == "None" || perfectBra == "Contact" || perfectBra == "Unavailable") {
                //     recommededBra = "";
                // }

                let unavailableCheck = document.querySelector('.suggestunavailable__unavailable-check');

                unavailableCheck.innerHTML = "Underbust: <b>" + underBust + "</b><br />Overbust: <b>" + overBust + "</b><br />";
            }
        }

        KlaviyoSubscribe.attachToForms('#email_signup', {
            hide_form_on_success: true,
            extra_properties: {
                "Bra Calc - Recommended Bra Style": `${perfectBra}`,
                "Bra Calc - Recommended Bra Size": `${perfectFit}`
            },
            success: function () {
                slider.next()
            }
        });
        
        slider.resize();
    });

    Array.from(dropdownOptions).forEach((dropdownOption) => {
        dropdownOption.addEventListener('click', ev => {
            nextButton.removeAttribute("disabled");
            nextButton.classList.add("nudge-me");

            let optionSelected = currentSlide.querySelector('.dropdown__option--selected').innerHTML;

            if (currentSlide.classList.contains('underbust')) {
                sizeAnswers.underbust = parseInt(optionSelected);
            } else if (currentSlide.classList.contains('overbust')) {
                sizeAnswers.overbust = parseInt(optionSelected);
            } else {
                return;
            }
        });
    });

    /* ATC functionality is not currently set up on the Impact theme */
    
    // // Sets the view product button to ajax the product into the cart
    // Array.from(addToCardButtons).forEach(button => {
    //     button.addEventListener('click', ev => {
    //         const resultVariantArray = JSON.parse(button.getAttribute('data-bsc-variants')).filter(variant => variant.variant_size == perfectFit)

    //         if (resultVariantArray.length > 0) {
    //             tmAddToCart(resultVariantArray[0].variant_id);

    //             ev.preventDefault()
    //             return false;
    //         }
    //     });
    // });
})();